import * as types from './mutation-types'
let defaultObject = () => ({
  data: {
    name: ''
  }
})

export default {
  [types.SET_ADMIN_ROLE] (state, payload) {
    if (payload === null) {
      payload = defaultObject()
    }
    state.admin_role = payload
  },
  [types.SET_ADMIN_ROLES] (state, payload) {
    state.admin_roles = payload.data
    state.pagination = payload.meta.pagination
  }
}
